export default __webpack_public_path__ + "static/media/pantry2-after1-1024w.b0785231.avif";